// JavaScript source code
import React from "react";
import "./css/AboutUs.css"; // Reusing the same modern CSS
import pictureOne from "./assets/picOne.png";

const InspectorateServices = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header inspectorate-header">
        <div className="overlay">
          <h1 className="page-title">Inspectorate Services</h1>
          <p className="subtitle">
            Ensuring compliance with standards, protecting consumers, and promoting fair trade across Malawi.
          </p>
        </div>
      </section>

      {/* === Introduction Section === */}
      <section className="intro-section">
        <div className="intro-card">
          <h2>About Inspectorate Services</h2>
          <p>
            The Inspectorate Services Department of the Malawi Bureau of Standards (MBS) is responsible for 
            enforcing standards compliance, conducting inspections, and monitoring quality across industries. 
            These services ensure that goods and services circulating in Malawi meet legal and technical 
            requirements, protecting both consumers and the marketplace.
          </p>
        </div>

        <div className="intro-card">
          <h2>Our Commitment</h2>
          <p>
            We are committed to impartial and consistent enforcement of standards, providing technical support 
            to businesses, and promoting a culture of compliance that enhances product safety and consumer confidence.
          </p>
        </div>
      </section>

      {/* === Core Inspectorate Functions === */}
      <section className="functions-section">
        <h2>Core Functions</h2>
        <ul>
          <li>
            <strong>Market Surveillance:</strong> Inspecting goods in markets, retail shops, and warehouses to 
            ensure compliance with MBS standards.
          </li>
          <li>
            <strong>Legal Metrology:</strong> Verification of weighing and measuring instruments used in trade 
            to guarantee accuracy and fairness.
          </li>
          <li>
            <strong>Product Compliance Audits:</strong> Checking products for conformity with national and 
            international standards.
          </li>
          <li>
            <strong>Consumer Protection:</strong> Preventing the sale of substandard, unsafe, or counterfeit products.
          </li>
          <li>
            <strong>Advisory Services:</strong> Providing guidance to manufacturers, importers, and service 
            providers on compliance requirements.
          </li>
        </ul>
      </section>

      {/* === Background and Mandate === */}
      <section className="background-section">
        <div className="text-content">
          <h2>Background</h2>
          <p>
            The Malawi Bureau of Standards Inspectorate Services operate under the mandate of the Standards Act 
            (Cap 51:02, amended 2012) to ensure compliance with national standards. The department is vital in 
            maintaining market integrity and safeguarding public health and safety.
          </p>

          <h2>Mandate</h2>
          <p>
            To enforce standards, conduct inspections, and verify the conformity of goods, services, and 
            trade instruments in Malawi, thereby promoting consumer protection, fair trade, and industrial growth.
          </p>
        </div>

        <div className="image-content">
          <img src={pictureOne} alt="Inspectorate Services" />
        </div>
      </section>

      {/* === Benefits Section === */}
      <section className="benefits-section">
        <h2>Benefits of Inspectorate Services</h2>
        <ul>
          <li>Protects consumers from unsafe and substandard products.</li>
          <li>Ensures fairness in trade and accuracy in measurements.</li>
          <li>Promotes compliance culture among manufacturers and service providers.</li>
          <li>Supports economic growth through a reliable and standardized marketplace.</li>
        </ul>
      </section>
    </div>
  );
};

export default InspectorateServices;
